import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";
import jobPoller from "./jobPoller";

export const getExportFileApi = async (verb,exportId,authHeaders) => {
    const requestedTimestamp = sessionStorage.getItem('exportRequestedTimestamp');

    const inputData = {
        channel: "CRM",
        verb: verb,
        exportId: exportId,
        requestedTimestamp: requestedTimestamp
    };
    const pollFn = async () => await apiCallPost(apiPaths.exportData, inputData, authHeaders);

    const checkFn = (res) => typeof res?.downloadURL === 'string' && res.downloadURL.trim() !== '';

    const initialResponse = await pollFn();

    if (!initialResponse || !initialResponse.exportId) {
        return { status: false, data: [], errMsg: 'Some Error Occurred' };
    }

    return await jobPoller(pollFn, checkFn, { interval: 3000, maxDuration: 25000 });
};